import cover_letter_1 from "../image/CoverImage/cover_letter_1.webp";
import cover_letter_2 from "../image/CoverImage/cover_letter_2.webp";
import basic_cover_letter_template from "../image/CoverImage/basic-cover-letter-template.webp";
import college_cover_letter_template from "../image/CoverImage/college-cover-letter-template.webp";
import combined_cover_letter_template from "../image/CoverImage/combined-cover-letter-template.webp";
import creative_cover_letter_template from "../image/CoverImage/creative-cover-letter-template.webp";
import executive_cover_letter_template from "../image/CoverImage/executive-cover-letter-template.webp";
import functional_cover_letter_template from "../image/CoverImage/functional-cover-letter-template.webp";
import general_cover_letter_template from "../image/CoverImage/general-cover-letter-template.webp";
import hybrid_cover_letter_template from "../image/CoverImage/hybrid-cover-letter-template.webp";
import it_cover_letter_template from "../image/CoverImage/it-cover-letter-template.webp";
import minimalist_cover_letter_template from "../image/CoverImage/minimalist-cover-letter-template.webp";
import modern_cover_letter_template from "../image/CoverImage/modern-cover-letter-template.webp";
import professional_cover_letter_template from "../image/CoverImage/professional-cover-letter-template.webp";
import simple_covder_letter_template from "../image/CoverImage/simple-cover-letter-template.webp";
import tech_cover_letter_template from "../image/CoverImage/tech-cover-letter-template.webp";
import traditional_cover_letter_template from "../image/CoverImage/traditional-cover-letter-template.webp";
import skill_based_cover_letter_template from "../image/CoverImage/skill-based-cover-letter-template.webp";

export const CoverImage = [
  { id: 201, src: cover_letter_1, alt: "cover letter", description: "" },
  { id: 202, src: cover_letter_2, alt: "", description: "" },
  {
    id: 203,
    src: basic_cover_letter_template,
    alt: "basic cover letter",
    description: "A classic but stylish design for the basic cover letter layout that has a minimalistic approach.",
  },
  // ... (all other entries as in your original)
  // (I'll abbreviate here for brevity – copy the rest from your original)
  // ...
  {
    id: 218,
    src: traditional_cover_letter_template,
    alt: "traditional cover letter template",
    description: "The traditional cover letter template is one of the most common formats that employers expect to see.",
  },
];